module.exports = __webpack_public_path__ + "static/media/arrow-icon.be389751.svg";